import React from "react";
import Modal from "react-bootstrap/Modal";
import translate from "../../services/Translation/lang";
import PrimaryButton from "../PrimaryButton";

const MultiplierPopup = ({ show, setShow }) => {
  const AdvancedAutoplayPreviewClose = "img/advanced-autoplay-preview-close.png";

  return (
    <Modal
      className="pop-up astronaut-popup advanced-autoplay-promo-popup multiplier-popup"
      show={show}
      onHide={() => setShow(false)}
      animation={false}
      backdropClassName="over-popup-backdrop"
      enforceFocus={false}
      onClick={() => setShow(false)}
    >
      <Modal.Body>
        <div className="astronaut-pop-up-body">
        <img
            className="aap-close"
            src={AdvancedAutoplayPreviewClose}
            onClick={() => setShow(false)}
            alt="advanced-autoplay-preview-close"
          />
          <div className="pop-up-message-box">
            <p className="pop-up-message-description">
              {translate('multiplier_ranges')}<br />
              {translate('aim_high')}
              
            </p>
          </div>
          <div className="pop-up-close">
            <PrimaryButton
              title={translate('ok_close')}
              onClick={() => setShow(false)}
            />
          </div>
        </div>
        
      </Modal.Body>
      
    </Modal>
  );
};

export default MultiplierPopup;
